import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagGU = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M10.91 45.652A24.883 24.883 0 0 0 25 50a24.883 24.883 0 0 0 14.09-4.348L25 43.478l-14.09 2.174ZM39.09 4.348A24.883 24.883 0 0 0 25 0a24.883 24.883 0 0 0-14.09 4.348L25 6.522l14.09-2.174Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M50 25c0-8.273-4.953-16.58-10.91-20.652H10.91C4.322 8.85 0 16.42 0 25c0 8.58 4.323 16.15 10.91 20.652h28.18C45.676 41.149 50 33.58 50 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M23.585 40.78c-.341-.292-8.368-7.27-8.368-15.78s8.027-15.488 8.368-15.78L25 8.006l1.415 1.212c.341.293 8.367 7.27 8.367 15.781 0 8.51-8.026 15.488-8.367 15.78L25 41.994l-1.415-1.212Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M32.609 25c0-7.61-7.609-14.131-7.609-14.131s-7.609 6.522-7.609 14.13c0 2.328.713 4.553 1.701 6.522h11.816c.988-1.969 1.7-4.194 1.7-6.522Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M32.609 25c0 2.327-.713 4.553-1.702 6.521L25 32.608l-5.908-1.087c-.988-1.968-1.7-4.194-1.7-6.521h15.217Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M25 39.13s3.664-3.143 5.907-7.61H19.092C21.335 35.988 25 39.13 25 39.13Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M20.108 20.652h9.783L25 25.543l-4.892-4.891Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M23.37 23.913h3.26v9.782h-3.26v-9.782Z"
}));
FlagGU.displayName = 'FlagGU';
export default withFlagWrapper(FlagGU);
//# sourceMappingURL=index.js.map